import UIkit from 'uikit';
import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

export default function () {
    let slides = {};
    let reviewsContainer = UIkit.util.$$('.tm-reviews');

    UIkit.util.each(reviewsContainer, (container) => {
        setTimeout(() => {
            let sliderEl = UIkit.util.$('.swiper', container);

            let sliderInstance = new Swiper(sliderEl, {
                speed: 400,
                slidesPerView: 1,
                spaceBetween: 60,
                autoHeight: true,
                loop: true,
                watchSlidesVisibility: true,
                simulateTouch: false,
                breakpoints: {
                    960: {
                      slidesPerView: 1.2,
                      spaceBetween: 100,
                    },
                    1264: {
                        slidesPerView: 1.3,
                        spaceBetween: 120,
                    },
                },
                navigation: {
                    nextEl: UIkit.util.$('.swiper-button-next', container),
                    prevEl: UIkit.util.$('.swiper-button-prev', container),
                },
                on: {
                    init: function () {
                        slides = this.slides;
                    },
                },
            });
        }, 1000);
    });
}



// WEBPACK FOOTER //
// ./scripts/partials/reviews.js